import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
     {
        _id: uuid(),
        title: "Nike Joy Ride Run",
        description: "Step into ultimate comfort in the Nike Joy Ride Run. Vapor X. Breathable mesh helps your feet stay cool and dry, while supportive overlays hug your foot during quick cuts and fast sprints.",
        price:"8000",
        category:"running",
        discount:"5000",
        image:"https://raw.githubusercontent.com/haarsh24/assets/main/1.webp",
        quantity:"1",
        rating:5
      },
      {
        _id: uuid(),
        title: "Nike React Infinity",
        description: "Shoot for the stars in the Nike React Infinity. It's lightweight and durable for out-of-this-world comfort. Peek underneath to reveal stars moulded into the sole to help you orbit around your next route",
        price:"3000",
        category:"running",
        discount:"4000",
        image:"https://raw.githubusercontent.com/haarsh24/assets/main/10.webp",
        quantity:"",
        rating:5
      },
      {
        _id: uuid(),
        title: "Nike Air Jordan Max",
        description: "The Nike Air Jordan Maxcombines comfortable foam cushioning, flexibility and support to get you moving in circuit-based fitness classes or while streaming workouts at home.",
        price:"3500",
        category:"running",
        discount:"4,500",
        image:"https://raw.githubusercontent.com/haarsh24/assets/main/9.webp",
        quantity:"",
        rating:4
      },
      {
        _id: uuid(),
        title: "Nike Air Force Max 2",
        description: "The Nike Air Force Max 2 features sleek lines and a sheer upper that combine classic Air Max elements into a lightweight, comfy and versatile icon. Together with its smart toe-down profile and extra lift, the Nike Air Force Max 2 offers an ever-bigger expression of Nike Air.",
        price:"4500",
        category:"running",
        discount:"5,500",
        image:"https://raw.githubusercontent.com/haarsh24/assets/main/8.webp",
        quantity:"",
        rating:3
      },
      {
        _id: uuid(),
        title: "Nike Air Force Max 2",
        description: "The Nike Air Force Max 2 has a low-profile silhouette that delivers durability, grip and responsive cushioning without sacrificing boardfe",
        price:"5500",
        category:"running",
        discount:"5,500",
        image:"https://raw.githubusercontent.com/haarsh24/assets/main/7.webp",
        quantity:"",
        rating:2
      },
      {
        _id: uuid(),
        title: "Nike Air Max 270",
        description: "The bold silhouette of Nike Air lifts the Nike Air Max 270 React to new heights, while the Nike React foam midsole delivers exceptional cushioning. Imagine all-day comfort with unstoppable styl",
        price:"2500",
        category:"sneakers",
        discount:"5,500",
        image:"https://raw.githubusercontent.com/haarsh24/assets/main/6.webp",
        quantity:"",
        rating:4
      },
      {
        _id: uuid(),
        title: "Nike Roshe 3",
        description: "With design elements inspired by the Roshe 3, the Jordan Air Max 200 brings a new level of Air to Jordan for all-day comfort.",
        price:"7000",
        category:"sneakers",
        discount:"5,500",
        image:"https://raw.githubusercontent.com/haarsh24/assets/main/5.webp",
        quantity:"",
        rating:4
      },
      {
        _id: uuid(),
        title: "Nike Metcom 5",
        description: "Crafted for comfort, the Nike Metcom 5 pairs a Zoom Air unit with a plush sockliner for responsive cushioning, round after round. The Oxford-inspired upper helps support your foot through your swing.",
        price:"6500",
        category: "sneakers",
        newArrival:true,
        discount:"5,500",
        image:"https://raw.githubusercontent.com/haarsh24/assets/main/3.webp",
        quantity:"",
        rating:4
      },
      {
        _id: uuid(),
        title: "Nike Phantom 2",
        description: "The Nike Phantom 2 is designed to help reduce injury and keep you on the run. More foam and improved upper details provide a secure and cushioned feel. Lace up and feel the potential as you hit the road",
        price:"9000",
        category: "sneakers",
        newArrival:true,
        discount:"5,500",
        image:"https://raw.githubusercontent.com/haarsh24/assets/main/3.webp",
        quantity:"",
        rating:5
      },
      {
        _id: uuid(),
        title: "Nike Revolution 5",
        description: "The Nike Revolution 5 is a balanced blend of classic design and forward-looking innovation. Nike React foam delivers lightweight, bouncy comfort, while rubber outsole pods and an exaggerated outsole offer a cutting-edge look that begs a reaction.",
        price:"12000",
        category: "sneakers",
        newArrival:true,
        discount:"5,500",
        image:"https://raw.githubusercontent.com/haarsh24/assets/main/4.webp",
        quantity:"",
        rating:3
      }
      
    
];
